import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  const { height, width } = props;
  return (
    <Svg
      width={width || 19}
      height={height || 23}
      viewBox="0 0 19 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_6672_218)">
        <Path
          d="M14.262 6.241v.5h2.835l1.403 13.77V20.544c0 1.093-.86 1.956-1.902 1.956H3.035c-1.041 0-1.902-.863-1.902-1.956v0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0l1.403-13.77h2.836V5.027C5.372 2.523 7.387.5 9.817.5s4.445 2.023 4.445 4.528V6.24zm-.913.5h.5V5.028c0-2.233-1.799-4.083-4.032-4.083-2.234 0-4.032 1.85-4.032 4.083V6.74h7.564z"
          fill="#fff"
          stroke="#000"
        />
        <Path
          d="M9.817 9.857c-2.623 0-4.75 2.207-4.75 4.929 0 2.721 2.127 4.928 4.75 4.928s4.75-2.207 4.75-4.928c0-2.722-2.127-4.929-4.75-4.929zm1.753 6.801l-.7-.003-1.053-1.304-1.053 1.303-.701.003a.086.086 0 01-.085-.088c0-.02.008-.04.02-.057l1.38-1.705-1.38-1.705a.094.094 0 01-.02-.057c0-.048.038-.088.085-.088l.7.004 1.054 1.303 1.053-1.302.7-.004c.046 0 .084.039.084.088 0 .021-.007.041-.02.058l-1.377 1.704 1.378 1.705c.013.016.02.036.02.057a.087.087 0 01-.085.088z"
          fill="#FF4D4F"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_6672_218">
          <Path fill="#fff" d="M0 0H19V23H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
